export default [
  /**
   * 费用查询首页
   */
  {
    path: "/fee",
    component: () => import("../page/fee/index")
  },
  /**
   * 门诊费用详情
   * @query.id
   * @cache.patInfo
   * @cache.mzDetail
   */
  {
    path: '/fee/mz/detail',
    component: () => import('../page/fee/mzdetail')
  },
  /**
   * 门诊费用查询
   * @query.index 常用就诊人索引
   */
  {
    path: '/fee/mz',
    component: () => import('../page/fee/mz'),
    redirect:
      '/fee/mz/0',
    children:
      [
        {
          path: ':tabIndex',
          component: () => import('../page/fee/mzlist')
        }
      ]
  },
  /**
   * 住院费用详情
   * @query.id
   * @cache.patInfo
   * @cache.zyDetail
   */
  {
    path: '/fee/zy/detail',
    component: () => import('../page/fee/zydetail')
  },
  /**
   * 住院费用查询
   * @query.index 常用就诊人索引
   */
  {
    path: '/fee/zy',
    component: () => import('../page/fee/zy'),
    redirect:
      '/fee/zy/0',
    children:
      [
        {
          path: ':tabIndex',
          component: () => import('../page/fee/zylist')
        }
      ]
  }
]



// WEBPACK FOOTER //
// ./src/router/fee.js